"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const n=e=>s=>s<=e,i=(e,s)=>t=>t>=e&&t<=s;exports.isInBetween=i;exports.isLessOrEq=n;
